import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const handleInquiryClick = (e) => {
    e.preventDefault();
    document.body.classList.add('open-modal');
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <h2>
            Let's create <span className="gradient-text">remarkable</span> results
          </h2>
          <p>Unlock your project's potential with our technology expertise</p>
          <Link
            to="/start-a-project"
            className="btn btn-secondary inquiry-link"
            onClick={handleInquiryClick}
          >
            <strong>
              Start A Project <span className="arrow"></span>
            </strong>
          </Link>
        </div>
        <div className="footer-bottom">
          <div className="row">
            <div className="col col-3">
              <div className="footer-logo">
                <img src="/assets/images/logo.svg" alt="Logo" />
              </div>
              <p>Empowering your business with innovative software solutions</p>
              <div className="badges">
                <div className="badge">
                  <a href="https://clutch.co/profile/slash-star" target="_blank" rel="noopener noreferrer">
                    <img src="/assets/images/logos/logo-clutch.svg" alt="Clutch" />
                  </a>
                </div>
                <div className="badge">
                  <img src="/assets/images/logos/logo-google-partner.svg" alt="Google Partner" />
                </div>
              </div>
            </div>
            <div className="col col-3">
              <div>
                <h3>Groton, USA</h3>
                <p>
                  360, Route 12,<br />
                  Groton, CT 06340 <br />
                  <a href="mailto:info@slashstar.co" className="link">
                    info@slashstar.co
                  </a>
                  <br />
                </p>
                <h3>Surat, India</h3>
                <p>
                  XR Studio LLP, <br />
                  3002, Silver Business Point,<br />
                  Uttran, Surat, GJ 394105<br />
                  <a href="mailto:info@slashstar.co" className="link" data-cursor="pointer">
                    info@slashstar.co
                  </a>
                  <br />
                </p>
              </div>
            </div>
            <div className="col col-3"></div>
            <div className="footer-links col col-3">
              <ul className="pages-link">
                <li>
                  <Link to="/product-design" className="link">
                    Digital Product Design
                  </Link>
                </li>
                <li>
                  <Link to="/mobile-development" className="link">
                    Mobile Development
                  </Link>
                </li>
                <li>
                  <Link to="/web-development" className="link">
                    Web Development
                  </Link>
                </li>
                <li>
                  <Link to="/backend-development" className="link">
                    Backend Development
                  </Link>
                </li>
                <li>
                  <Link to="/blockchain-development" className="link">
                    Block Chain Development
                  </Link>
                </li>
                <li>
                  <Link to="/ai-development" className="link">
                    AI Development
                  </Link>
                </li>
              </ul>
            </div>
            <div className="footer-links col col-3">
              <ul className="pages-link">
                <li>
                  <Link to="/portfolio" className="link">
                    Portfolio
                  </Link>
                </li>
                <li>
                  <Link to="/about-us" className="link">
                    About us
                  </Link>
                </li>
                <li>
                  <Link to="/contact-us" className="link">
                    Contact us
                  </Link>
                </li>
                <li>
                  <Link to="/terms-and-conditions" className="link">
                    Terms & Conditions
                  </Link>
                </li>
                <li>
                  <Link to="/privacy-policy" className="link">
                    Privacy Policy
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-copyright flex-space-between">
          <div className="copyright-text">
            Copyright © 2024 Slash Star. All rights reserved
          </div>
          <div className="social">
            <a
              href="https://www.linkedin.com/company/slashstar/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/assets/images/icon/social/linkedin.svg" alt="Linkedin" />
            </a>
            <a
              href="https://www.behance.net/slashstar"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/assets/images/icon/social/behance.svg" alt="Behance" />
            </a>
            <a
              href="https://dribbble.com/slashstar"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/assets/images/icon/social/dribble.svg" alt="Dribbble" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
